(function () {
  const now = () => Date.now();

  function storage() {
    try { return window.localStorage; } catch { return null; }
  }

  function intOr(v, fb) {
    const n = parseInt(String(v ?? ''), 10);
    return Number.isFinite(n) ? n : fb;
  }

  function dismissed(ls, key) {
    if (!ls || !key) return false;
    const until = intOr(ls.getItem(key), 0);
    return until > 0 && now() < until;
  }

  function setDismissed(ls, key, days) {
    if (!ls || !key) return;
    const d = Math.max(1, intOr(days, 30));
    ls.setItem(key, String(now() + d * 24 * 60 * 60 * 1000));
  }

  function init(el) {
    const ls = storage();
    const key = el.getAttribute('data-storage-key') || '';
    const days = el.getAttribute('data-remember-days') || '30';

    if (dismissed(ls, key)) {
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
      return;
    }

    const btn = el.querySelector('[data-evr-announcement-close]');
    if (!btn) return;

    btn.addEventListener('click', () => {
      setDismissed(ls, key, days);
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
    });
  }

  const boot = () => document.querySelectorAll('[data-evr-announcement]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
})();